import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

interface AdminEmailSearch {
  dialog?: "new" | "edit";
  id?: string;
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  validateSearch: (raw: Record<string, unknown>): AdminEmailSearch => {
    const dialog = raw.dialog === "new" || raw.dialog === "edit" ? raw.dialog : undefined;
    return {
      dialog,
      id: dialog === "edit" && typeof raw.id === "string" && raw.id !== "" ? raw.id : undefined,
    };
  },
  component: AdminEmailPage,
});
